import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ message = "Processing your request...", submitting = false }) => {
    if (!submitting) return null;

    return (
        <div className="custom-progress-overlay">
            <div className="custom-progress-content">
                <div className="spinner-wrapper">
                    <div className="premium-spinner"></div>
                </div>
                <div className="progress-container-outer">
                    <div className="progress-container-inner">
                        <div className="premium-progress-bar"></div>
                    </div>
                </div>
                <div className="progress-message">{message}</div>
            </div>
        </div>
    );
};

export default ProgressBar;
